// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"71d0e2f2","722":"ef63505a","787":"7e834572","963":"30c718f4"}[chunkId] + ".chunk.js";
};